
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("966Nd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2ca764d14cbba5b5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $9HHOs = parcelRequire("9HHOs");

var $gokBr = parcelRequire("gokBr");
/**
 * Renders a spotlight card if it is currently active.
 */ const $2ca764d14cbba5b5$var$SpotlightTourCard = ({ cardKey: cardKey, ...spotlightProps })=>{
    const [isActiveCard] = (0, $gokBr.useIsActiveSpotlightCard)(cardKey);
    return isActiveCard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9HHOs.JiraSpotlight), spotlightProps);
};
var $2ca764d14cbba5b5$export$2e2bcd8739ae039 = $2ca764d14cbba5b5$var$SpotlightTourCard;

});


//# sourceMappingURL=async-issue-navigator-changeboarding-spotlight-tour-card.406617ef.js.map
